














































































import Vue from "vue";
import moment from "moment";
import type { GiftcardObject } from "@/views/customer-dashboard/types/index";
import { solveCurrencySymbol } from "@/common/common";
import StatusTag from "./StatusTag.vue";
import vIcon from "@/components/v-components/v-icon.vue";
import { formatPrice, formatDateAsDuration } from "@/utils/formatters";

export default Vue.extend({
  name: "GiftCardComponent",

  components: { StatusTag, vIcon },

  props: {
    giftcard: {
      type: Object as () => GiftcardObject,
      required: true
    }
  },

  data: () => {
    return {
      codeCopied: false
    }
  },

  methods: {
    solveCurrencySymbol,
    formatDate(ts: number): string {
      if (!ts) return "-";
      return moment.unix(ts).format("DD.MM.YYYY");
    },

    formatValid(valid: number) {
      return formatDateAsDuration(valid);
    },

    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.giftcard.card_code);
        this.codeCopied = true;

        setTimeout(() => (this.codeCopied = false), 1000);
      } catch (err) {
        console.error('could not copy to clipboard');
      }
  },

    getTitle(title?: { [index: string]: string | undefined }) {
      if (!title) return "";
      return title.en || title.fi || Object.values(title)[0] || "";
    },

    formatBalance(balance: number): string | number {
      const locale = this.$i18n.locale;
      const currency = this.giftcard?.currency ? this.giftcard?.currency : 'EUR';

      if (isNaN(balance)) return "";
      if (this.giftcard.type === "value") return formatPrice(balance, locale, currency);
      return `${balance}x`;
    },

    getIndicatorClass() {
      const isExpired = moment().unix() > this.giftcard.valid_until;

      if (isExpired) return 'expired'
      else if (this.giftcard.balance > 0) return 'active';
      return 'used';
    },

    getStatusTagType() {
      const isExpired = moment().unix() > this.giftcard.valid_until;

      if (this.giftcard.balance > 0 && !isExpired) return 'green';
      return 'red';
    }
  }
});
